import { useHelp } from './HelpContext';
import { Search, BookOpen } from 'lucide-react';
import { Drawer } from '@ui/components/Drawer';

export function HelpDrawer() {
  const { isOpen, close, helpContent, isLoading, currentRoute } = useHelp();

  return (
    <Drawer
      open={isOpen}
      title="Help"
      onClose={close}
      className="sm:max-w-xl lg:max-w-2xl"
      locked={false}
    >
      <div className="mb-4">
        <div className="flex items-center gap-2 text-xs text-slate-500 mb-3">
          <span className="flex items-center gap-1">
            <BookOpen className="h-3 w-3" aria-hidden />
            Contextual help for the current screen
          </span>
          <span className="text-slate-700">{currentRoute || '—'}</span>
        </div>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-500" aria-hidden />
          <input
            type="search"
            placeholder="Search help…"
            className="w-full rounded border border-slate-700 bg-slate-900 px-8 py-2 text-sm text-slate-100 placeholder-slate-500"
            aria-label="Search help content"
          />
        </div>
      </div>

      <div
        className="prose prose-invert prose-sm max-w-none text-slate-300"
        dangerouslySetInnerHTML={{ __html: isLoading ? '<p class="text-slate-500 text-center py-8">Loading help…</p>' : helpContent }}
      />

      <div className="mt-4 pt-4 border-t border-slate-800 flex items-center justify-between text-xs text-slate-500">
        <span>Press <kbd className="px-1.5 py-0.5 rounded bg-slate-800 border border-slate-700">Esc</kbd> to close</span>
        <a
          href="#/help"
          className="flex items-center gap-1 hover:text-slate-300"
          onClick={close}
        >
          <BookOpen className="h-3 w-3" aria-hidden />
          Open full help
        </a>
      </div>
    </Drawer>
  );
}
